import { Component, OnInit, OnDestroy, TemplateRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { BsLocaleService } from 'ngx-foundation';
import { ProfileService } from '../_services/profiles.service';
import { Profile } from '../_models/profile.model';
import { Subscription } from 'rxjs/Subscription';
import { SearchParameters } from '../_viewmodels/search-params.viewmodel';
import { SearchService } from '../_services/search.service';
import { CertificadoAfiliado } from '../_models/certificado-afiliado.model';
import { User } from '../_models/user.model';
import { AuthenticationService } from '../_services/authentication.service';
import { EnvironmentService } from '../_services/environment.service';
import { HttpErrorResponse } from '@angular/common/http';
import { DomSanitizer, SafeResourceUrl, SafeUrl} from '@angular/platform-browser';

import { ModalService } from '../_services/modal.service';
import { Router } from '@angular/router';
import {Location} from '@angular/common';
import { stringify } from 'querystring';
import { getDate } from 'ngx-foundation/chronos/utils/date-getters';


@Component({
  selector: 'app-certificados',
  templateUrl: './certificados.component.html',
  styleUrls: ['./certificados.component.scss'],
  providers: [SearchService],
})
export class CertificadosComponent implements OnInit, OnDestroy {

  error: boolean;
  loading: boolean;
  isEmpty: boolean;
  ruta:string;
  rutaPdf:string;
  searchHasBeenMade: boolean;
  modalRadicado: string;
  currentProfile: Profile;
  currentUser: User;
  public isCollapsed = false;
  profileSubscription: Subscription;
  certificados: CertificadoAfiliado[];
  showVerButton = true;
  //urlPdf: SafeResourceUrl;

  constructor(
    private profilesService: ProfileService,
    private localeService: BsLocaleService,
    private searchService: SearchService,
    private authenticationService: AuthenticationService,
    private envService: EnvironmentService,
    private _modalService: ModalService,
    private location: Location,
    private router: Router,
    public sanitizer:DomSanitizer,) {
      //this.showVerButton = this.envService.showDocumentViewer;
      this.localeService.use('es');
      //this.ruta = window.location.href.substr(0, window.location.href.indexOf('/certificados'));
      this.ruta = this.envService.urlPdf;
  }

  checkUserToken() {
    // let isTokenValid = false;
    this.authenticationService.checkUserToken()
      .subscribe((response: any) => {

      },
      error => {

      });
  }

  ngOnInit() {
    this.checkUserToken();
    this.loading = false;
    this.error = false;
    this.isEmpty = false;
    this.searchHasBeenMade = false;
    this.currentProfile = this.profilesService.getSelectedProfile();
    // Subscribe to user's profile change
    this.profileSubscription = this.profilesService.selectedProfileSubject.subscribe(
      (profile: Profile) => {
        this.currentProfile = profile;
        this.currentUser = this.authenticationService.currentUserValue;
      }
    );
    this.certificados = [];
    //this.urlPdf= this.sanitizer.bypassSecurityTrustResourceUrl(this.url);
  }

  ngOnDestroy() {
    this.profileSubscription.unsubscribe();
  }

  cleanSearchFilters(form: NgForm) {
    form.resetForm();
  }



  onSubmitSearch(form: NgForm) {
    this.checkUserToken();
    this.loading = true;
    this.error = false;
    this.searchHasBeenMade = true;
    this.certificados = [];
    const fvalue = form.value;

    // Asignar fecha a primera hora del día escogido.
    if (fvalue.fechaTramiteDesde) {
      fvalue.fechaTramiteDesde.setHours(0, 0, 0);
    }
    // Asignar fecha a última hora del día escogido.
    if (fvalue.fechaTramiteHasta) {
      fvalue.fechaTramiteHasta.setHours(23, 59, 59);
    }

    const searchParameters: SearchParameters = new SearchParameters();
    Object.assign(searchParameters, form.value as SearchParameters);
    // Cambiar Asignación Fecha Desde
    searchParameters.fechaTramiteDesde = fvalue.fechaTramiteDesde
      ? fvalue.fechaTramiteDesde.toISOString()
      : '';
    // Cambiar Asignación Fecha Hasta
    searchParameters.fechaTramiteHasta = fvalue.fechaTramiteHasta
      ? fvalue.fechaTramiteHasta.toISOString()
      : '';
    // Cambiar Asignación Radicado
    searchParameters.radicado = fvalue.radicado
    ? fvalue.radicado
    : '';
    // Cambiar Asignación Tipo Identificacion afiliado
    searchParameters.tipoIdentificacionAfiliado = fvalue.tipoIdentificacionAfiliado
      ? fvalue.tipoIdentificacionAfiliado
      : '';

      // Determinar si son tramites masivos o individuales
    searchParameters.tipoTramite = "";
    if (fvalue.individual && !fvalue.masivos) searchParameters.tipoTramite="individuales";
    if (fvalue.masivos && !fvalue.individual) searchParameters.tipoTramite="masivos";
    // INICIO Datos Obligatorios Para Consulta
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      // Asignar Perfil Actual
      searchParameters.currentProfileName = this.currentProfile.profile_name
        ? this.currentProfile.profile_name
        : '';
      // Asignar Tipo Identificacion Afiliado
      searchParameters.tipoIdfAfiliado = this.currentUser.TipoIdentificacion
        ? this.currentUser.TipoIdentificacion
        : '';
      // Asignar Número Identificación Afiliado
      searchParameters.idfAfiliado = this.currentUser.NoIdentificacion
        ? this.currentUser.NoIdentificacion
        : '';
      // Asignar Número de Identificación Empresa
      searchParameters.idfEmpresa = this.currentProfile.profile_company_id
        ? this.currentProfile.profile_company_id
        : '';
    } else {
    }
    // FIN Datos Obligatorios Para Consulta
    // Domsanitizer

//
    this.searchService.searchCertificados(searchParameters).subscribe(
      response => {
        this.error = false;
        this.loading = false;
        var d = new Date();
        var inicial = new Date();
        inicial.setDate(d.getDate() - 5);
        var certificadostemp = [];
        if (response.length === 0) {
          this.isEmpty = true;
        } else {
          this.isEmpty = false;
        }
        // mi  response
        //response = '[ { "tocid": 2213718, "radicado": "2000202711", "tipoCertificado": "CERTIFICACIÓN AFILIACIÓN TRABAJADOR", "tipoIdentificacionEmpresa": "NIT", "identificacionEmpresa": "9008182827", "fechaCertificado": "2020-06-16T10:56:14", "tipoIdentificacionAfiliado": "CC", "identificacionAfiliado": "1064710875", "nombreAfiliado": null, "historial": null }, { "tocid": 2213738, "radicado": "2000202715", "tipoCertificado": "CERTIFICACIÓN AFILIACIÓN TRABAJADOR", "tipoIdentificacionEmpresa": "NIT", "identificacionEmpresa": "9008182827", "fechaCertificado": "2020-06-16T10:57:19", "tipoIdentificacionAfiliado": "CC", "identificacionAfiliado": "1064710875", "nombreAfiliado": null, "historial": null }, { "tocid": 2214042, "radicado": "2000202802", "tipoCertificado": "CERTIFICACIÓN AFILIACIÓN TRABAJADOR", "tipoIdentificacionEmpresa": "NIT", "identificacionEmpresa": "9008182827", "fechaCertificado": "2020-06-16T11:18:13", "tipoIdentificacionAfiliado": "CC", "identificacionAfiliado": "1064710875", "nombreAfiliado": "CHAVEZ RIVERA LUIS EMIRO", "historial": "CERTIFICADO GENERADO. NOTIFICACION ENVIADA A afiliaciones2014@hotmail.com EL 16/06/2020 11:18:29 a.m." }]';
        //
        //certificadostemp = [{"tocid":2213718,"radicado":"2000202711","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T10:56:14","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":null,"historial":null},{"tocid":2213738,"radicado":"2000202715","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T10:57:19","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":null,"historial":null},{"tocid":2214042,"radicado":"2000202802","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T11:18:13","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A afiliaciones2014@hotmail.com EL 16/06/2020 11:18:29 a.m."},{"tocid":2214139,"radicado":"2000202817","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T11:25:18","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A afiliaciones2014@hotmail.com EL 16/06/2020 11:25:40 a.m."},{"tocid":2215182,"radicado":"2000203061","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T12:44:06","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A afiliaciones2014@hotmail.com EL 16/06/2020 12:44:26 p.m."},{"tocid":2217437,"radicado":"2000203580","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"9008182827","fechaCertificado":"2020-06-26T16:32:20","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A afiliaciones2014@hotmail.com EL 16/06/2020 4:32:36 p.m."},{"tocid":2239285,"radicado":"2000208486","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"8600135703","fechaCertificado":"2020-06-19T16:47:47","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A mblanco@cafam.com.co EL 19/06/2020 5:09:52 p.m."},{"tocid":2239289,"radicado":"2000208490","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"8600135703","fechaCertificado":"2020-06-19T16:47:59","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A mblanco@cafam.com.co EL 19/06/2020 5:09:58 p.m."},{"tocid":2245316,"radicado":"2000210036","tipoCertificado":"CERTIFICACIÓN PAGO CUOTA MONETARIA TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"8600135703","fechaCertificado":"2020-06-23T09:20:45","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A mblanco@cafam.com.co EL 23/06/2020 9:21:02 a.m."},{"tocid":2245353,"radicado":"2000210045","tipoCertificado":"CERTIFICACIÓN AFILIACIÓN TRABAJADOR","tipoIdentificacionEmpresa":"NIT","identificacionEmpresa":"8600135703","fechaCertificado":"2020-06-23T09:27:22","tipoIdentificacionAfiliado":"CC","identificacionAfiliado":"1064710875","nombreAfiliado":"CHAVEZ RIVERA LUIS EMIRO","historial":"CERTIFICADO GENERADO. NOTIFICACION ENVIADA A mblanco@cafam.com.co EL 23/06/2020 9:27:38 a.m."}];
        if (!this.isEmpty)
        {
          var index = 0;
          response.forEach(element => {
            index ++;
            var fecha = new Date(element.fechaCertificado);
            //
            element.urlPdf = this.ruta + element.nombreArchivo + '.pdf';
            //element.urlPdf = 'https://pruformslf2.cafam.com.co/CFMPortal/Pdfs/'+ element.radicado + '.pdf';
            element.urlLaserDoc = this.envService.tvURL + element.tocid;
            if (!this.doesFileExist(element.urlPdf) ){
              element.urlPdf = '';
            }
            if (this.currentProfile.profile_name == 'Funcionario Subsidio'){
              this.certificados.push(element);
            }else {
              if (fecha >= inicial ){
                this.certificados.push(element);
              }
            }
          });
        }
      },
      error => {
        this.isEmpty = true;
        this.loading = false;
        this.error = true;
        const errorObject = error as HttpErrorResponse;
        if (errorObject.status === 401) {
          this.authenticationService.logout();
          this.router.navigate(['/logout']);
          // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
          // location.replace(logBackURL);
        }
      }
    );

  }
  openModalCertificado(modalId: string, rutaPdf:string){
      this.checkUserToken();
      this.modalRadicado = "";
      const URL: string = rutaPdf;
      this._modalService.open(modalId);
      const ifr: HTMLIFrameElement = document.createElement('iframe');
      ifr.setAttribute('id', 'embeeded-frame');
      ifr.setAttribute('frameborder', '0');
      ifr.setAttribute('width', '100%');
      ifr.setAttribute('height', '100%');
      document.getElementById('iframe-goes-here').appendChild(ifr);
      ifr.contentWindow.location.replace(URL);
  }

  openModal(modalId: string, radicado: string) {
    const searchParameters: SearchParameters = new SearchParameters();
    // Cambiar Asignación Fecha Desde
    searchParameters.radicado = radicado;

    // INICIO Datos Obligatorios Para Consulta
    this.currentUser = this.authenticationService.currentUserValue;
    if (this.currentProfile && this.currentUser) {
      // Asignar Perfil Actual
      searchParameters.currentProfileName = this.currentProfile.profile_name
        ? this.currentProfile.profile_name
        : '';
      // Asignar Tipo Identificacion Afiliado
      searchParameters.tipoIdfAfiliado = this.currentUser.TipoIdentificacion
        ? this.currentUser.TipoIdentificacion
        : '';
      // Asignar Número Identificación Afiliado
      searchParameters.idfAfiliado = this.currentUser.NoIdentificacion
        ? this.currentUser.NoIdentificacion
        : '';
      // Asignar Número de Identificación Empresa
      searchParameters.idfEmpresa = this.currentProfile.profile_company_id
        ? this.currentProfile.profile_company_id
        : '';
    }

    // console.log('Search start!');

    this.searchService
      .searchCertificados(searchParameters)
      .subscribe(
        (response: CertificadoAfiliado[]) => {

          // console.log('Search end!');
          const id = response[0].tocid;
          this.modalRadicado = radicado;
          const reg: RegExp = new RegExp(this.envService.tocid, 'g');
          const URL: string = this.envService.tvURL.replace(reg, id.toString());
          this._modalService.open(modalId);
          const ifr: HTMLIFrameElement = document.createElement('iframe');
          ifr.setAttribute('id', 'embeeded-frame');
          ifr.setAttribute('frameborder', '0');
          ifr.setAttribute('width', '100%');
          ifr.setAttribute('height', '100%');
          document.getElementById('iframe-goes-here').appendChild(ifr);
          ifr.contentWindow.location.replace(URL);
        },
        error => {
          // console.log('Search error!');
          const errorObject = error as HttpErrorResponse;
          if (errorObject.status === 401) {
            this.authenticationService.logout();
            this.router.navigate(['/logout']);
            // const logBackURL = this.envService.cafamLoginURL + this.envService.appReturnURL;
            // location.replace(logBackURL);
          }
        }
      );
  }

  closeModal(id: string) {
    this._modalService.close(id);
    // document.getElementById('embeeded-frame').remove();
    document.getElementById('iframe-goes-here').removeChild(document.getElementById('embeeded-frame'));
  }
///
  public urlExists(url: string) : string {
    let promise = fetch(url, {mode: "no-cors"}).then(function(response){
      if (response.ok)
      {
        return "SI";
      }
      else
      {
        return "NO";
      }
    })
    .catch(function(error){
      return "NO";
    }) ;
    return "NO";
  }
  ///
  public doesFileExist(urlToFile: string) {
    var xhr = new XMLHttpRequest();
    xhr.open('HEAD', urlToFile, false);
    xhr.send();

    if (xhr.status == 404) {
        return false;
    } else {
        return true;
    }
  }

}
